import React from 'react';
import { PhoneIcon } from 'lucide-react';
import { Wordmark } from './Wordmark';
import { PHONE_DISPLAY, PHONE_HREF, StartCta } from './CtaButton';
export function Header() {
  return <header className="sticky top-0 z-40 border-b border-brand-white/15 bg-brand-black" data-id="element-34" data-mp="2ilqtmkyip56r">
      <div className="mx-auto flex max-w-6xl items-center justify-between gap-4 px-5 py-4 sm:px-8" data-id="element-35" data-mp="2nkkbepku7icq">
        <Wordmark onDark data-id="element-36" data-mp="2rm5i1t6s30eh" />
        <div className="flex items-center gap-3 sm:gap-5" data-id="element-37" data-mp="2rmxd92wgqw48">
          <a href={PHONE_HREF} className="inline-flex items-center gap-2 font-display text-sm font-bold text-brand-white transition-colors duration-150 ease-out hover:text-brand-red focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-red sm:text-base" data-id="element-38" data-mp="2rkb634dhiimj">
            <PhoneIcon className="h-4 w-4 text-brand-red" aria-hidden="true" data-id="element-39" data-mp="3baxv9st9qaw8" />
            <span className="hidden sm:inline" data-id="element-40" data-mp="3fbgkrg7ov4v9">{PHONE_DISPLAY}</span>
            <span className="sr-only sm:hidden" data-id="element-41" data-mp="3f9nbdt5oy6jk">Call {PHONE_DISPLAY}</span>
          </a>
          <StartCta className="hidden md:inline-flex" data-id="element-42" data-mp="2wm5ompcqaiva" />
        </div>
      </div>
    </header>;
}